// DOM-specific JS should be done here
// see /boilerplate/src/js/browser.js for the import pattern

// Pinned to 4.3.9: the last MIT-licensed release (v5+ is GPL-3.0 and a
// protocol rewrite). fintactix.com's child page already loads the matching
// v4-era iframeResizer.contentWindow.min.js.
import { iframeResize } from 'iframe-resizer';

// browser.js targets this module at `iframe[src^="https://www.fintactix.com"]`
// directly, so `el` here is the iframe itself, not a wrapping element.
export const FintactixCalculator = (el) => {
  iframeResize(
    {
      checkOrigin: ['https://www.fintactix.com'],
      heightCalculationMethod: 'lowestElement',
    },
    el
  );
};

export default FintactixCalculator;
